// 消除拦截器和请求调用处对token过期的重复提示
/**
 * 判断是否被拦截处理的返回码，返回true，表示被拦截
 * 此方法的作用是调用处，无需处理被拦截的返回码的错误提示
 * @param {请求的返回码} code
 */
export default {
  isInterceptorCode(code) {
    switch (code) {
      case 1001: //登录失效
      case 1002: //强制下线
        return true;
      case 1003: //强制下线
        return true;
      case 404: //404
      case 500: //未知错误
      default:
        break;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/common/commonFuncs.js